/**
 * Marks a click as "already handled inside the row" so the row-level
 * navigation handler skips it — WITHOUT calling stopPropagation().
 *
 * React's SyntheticEvent.stopPropagation() also calls
 * nativeEvent.stopPropagation(). Because React attaches its listeners at the
 * root container, that stops the NATIVE event from ever reaching `document` —
 * which is exactly where Radix's DismissableLayer listens in order to dismiss
 * an open popover. Cells that wrap a per-row Popover (e.g. the tag editor)
 * and stop propagation meant another row's open popover never got dismissed
 * and the panels stacked on top of each other.
 *
 * Flagging the native event instead keeps row navigation suppressed while
 * letting the event bubble on to `document`, so Radix can still dismiss.
 * Portaled popover content is covered too: React bubbles portal clicks through
 * the React tree, so the cell handler still runs for them.
 */
type RowNavEvent = MouseEvent & { __rowNavHandled?: boolean };

export const skipRowNav = (e: React.MouseEvent) => {
  (e.nativeEvent as RowNavEvent).__rowNavHandled = true;
};

export const isRowNavHandled = (e: React.MouseEvent) =>
  (e.nativeEvent as RowNavEvent).__rowNavHandled === true;
